import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import HttpService from "../services/httpService";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { ROLENAME } from "../utils/index";
import { CSVLink } from "react-csv";
import moment from "moment";
import { setUserDetails } from "../redux/actions/userAction";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  FormControlLabel, RadioGroup, FormControl, Radio, Button, Checkbox,TableRow, TableHead, TableContainer, TableCell, TableBody, Table, Paper, TextField, TablePagination, Dialog, DialogTitle,DialogActions,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    marginTop: 20
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  checkbox: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 50,
  },
  tableViewButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "30%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  boardViewButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "30%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  downloadCsvButton: {
    backgroundColor: "#a7f2af",
    color: "#151921",
    padding: "2",
    marginRight: "0.5em",
    borderRadius: "20px",
    "&:hover": { backgroundColor: "#124a17", color: "white" },
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const RefundApproval = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [type,setType] = useState('all');
  const [allLeadData, setAllLeadData] = useState([])
  const [allData, setAllData] = useState([]);
  const [selectedRefunds, setSelectedRefunds] = useState({});
  const [csvData, setCsvData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20); //limit
  const [totalCount, setTotalCount] = useState(0);
  const [paidDialog, setPaidDialog] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [transactionAttachment, setTransactionAttachment] = useState('');
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [leadId, setLeadId] = useState('');
  const [remark, setRemark] = useState('');
  const [requestType, setrequestType] = useState("")
  const [quotationId, setQuotationId] = useState("")
  const [payloadForQuotation , setPayloadForQuotation] = useState({})
  const [leadIdOfQuotaion, setLeadIdOfQuotaion] = useState("")
  const [erpProjectId, setErpProjectId] = useState('')
  const [refundArrayObjId, setRefundArrayObjId] = useState('');
  const [quotationPaidData, setQuotationPaidDate] = useState();
  const buttonRef = useRef(null);

  const headers = [
    { key: "customerName", label: "Customer Name" },
    { key: "lead_no", label: "Lead No" },
    { key: "uniqueLeadNumber", label: "uniqueLeadNumber"},
    { key: "erpProjectNo", label: "Project No." },
    { key: "department", label: "Department" },
    { key: "status", label: "Status" },
    { key: "currentStage", label: "Current Stage" },
    { key: "assignTo", label: "Assign To" },
    { key: "refundRaisedUser", label: "Refund Raise User" },
    { key: "refundAmount", label: "Refund Amount" },
    { key: "type", label: "Request Type" },
    { key: "refundStatus", label: "Refund Status" },
    { key: "raiseDate", label: "Refund Raised Date" },
    { key: "approveDate", label: "Refund Approve Date" }
];

  useEffect (()=>{
    handleSubmit();
  },[]);

  const downloadExcel = () => {
    props.setLoading(true);
    try {
        setTimeout(() => {
            buttonRef.current.link.click();
        });
    } catch (err) {
        console.error(err.message);
    }
    props.setLoading(false)
  }

  const downloadCsv = async () => {
    props.setLoading(true)
    let finalData = [];

    for (let l = 0; l < allLeadData?.length; l++) {
      let filteredRefunds  =  allLeadData[l]?.totalAmountRefundedArray;

      for (let r = 0; r < filteredRefunds?.length; r++) {
        let refund = filteredRefunds[r];
        let obj = {
          customerName: allLeadData[l]?.customerName,
          lead_no: allLeadData[l]?.lead_no,
          uniqueLeadNumber: allLeadData[l]?.uniqueLeadNumber || 'NA',
          erpProjectNo: allLeadData[l]?.erpProjectNo || '-',
          department: allLeadData[l]?.departmentName,
          status: allLeadData[l]?.status,
          currentStage: allLeadData[l]?.currentStage,
          assignTo: allLeadData[l]?.assignTo,
          refundRaisedUser: allLeadData[l]?.refundRaiseUser,  // Example of refund-specific data
          refundAmount: refund?.amountRefunded,
          type:"Refund Request",
          refundStatus: refund?.isPaid ? 'Paid' : 'Unpaid',
          raiseDate: refund.refundRaiseDate ? moment(refund.refundRaiseDate).format('DD-MM-YYYY') : '-',
          approveDate: refund.refundApprovedFinanceDate ? moment(refund.refundApprovedFinanceDate).format('DD-MM-YYYY') : '-'
        };
        finalData.push(obj);
      }
    }

    const filterBalanceSheetObject = allLeadData.filter(
      (ele) => ele?.balanceSheetDataObj && Object.keys(ele.balanceSheetDataObj).length > 0
    );
    if(filterBalanceSheetObject.length>0){
      const flattenDataForQuotation = filterBalanceSheetObject.map((item) => {
        return {
          customerName: item?.customerId?.name,
          lead_no:  item?.lead_no,
          uniqueLeadNumber: item?.uniqueLeadNumber || 'NA',
          erpProjectNo: item?.erpProjectNo || '-',
          department: item?.departmentName,
          status: item?.status,
          currentStage: item?.currentStage,
          assignTo: item?.assignTo?.name,
          refundRaisedUser: item?.raisedUser, 
          refundAmount: item?.balanceSheetDataObj?.pendingDueAmount,
          type:"Quotation Change Request",
          refundStatus: item?.balanceSheetDataObj?.paidInfo?.isPaid ? 'Paid' : 'Unpaid',
          raiseDate: item.raiseDate ? moment(item.raiseDate).format('DD-MM-YYYY') : '-',
          approveDate: item?.balanceSheetDataObj?.paidInfo?.paidDate ? moment(item?.balanceSheetDataObj?.paidInfo?.paidDate).format('DD-MM-YYYY') : '-'
        };
      });
      setCsvData([...finalData , ...flattenDataForQuotation])
      downloadExcel()
    }
    else{
      setCsvData(finalData)
      downloadExcel()
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(+event.target.value, 10));
    setPage(0);
  };

  const clearFilterDate = () => {
    setStartDate("");
    setEndDate("");
    setType('');
    setAllData([])
  };

  const handleSubmit = async () => {
    props.setLoading(true);
    try {
      let obj = {
        startDate: startDate,
        endDate: endDate,
        type: type
      };
      let res = await HttpService.getFinanceRefundLead(obj);
      setAllLeadData([...res.data.refundRequestData, ...res.data.quotationChangeRequest]); 
      let data = res.data.refundRequestData;
      let sum = 0;
      let dataArray = [];

      function createDataObj(row, refund) {
        return {
          projectId: row?._id,
          customerName: row?.customerName,
          lead_no: row?.lead_no,
          uniqueLeadNumber: row?.uniqueLeadNumber || 'NA',
          erpProjectNo: row?.erpProjectNo || '-',
          erpProjectId: row?.erpProjectId,
          departmentName: row?.departmentName,
          status: row?.status,
          currentStage: row?.currentStage,
          assignTo: row?.assignTo,
          refundRaiseUser: row?.refundRaiseUser,
          amountRefunded: refund?.amountRefunded,
          refundId: refund?._id,
          refundStatus: refund?.isPaid,
          refundRaiseDate: refund?.refundRaiseDate,
          refundApprovedFinanceDate: refund?.refundApprovedFinanceDate
        };
      } 

      for (let i = 0; i < data.length; i++) {
        let array;
        if (type === 'paid') {
          array = data[i].totalAmountRefundedArray?.filter(refund => refund.isPaid);
        } else if (type === 'unPaid') {
          array = data[i].totalAmountRefundedArray?.filter(refund => !refund.isPaid);
        } else {
          array = data[i].totalAmountRefundedArray; 
        }
      
        sum += array?.length || 0;
      
        for (let j = 0; j < array.length; j++) {
          dataArray.push(createDataObj(data[i], array[j]));
        }
      }
      setAllData([...dataArray, ...res?.data?.quotationChangeRequest]);
      setTotalCount(sum + res?.data?.quotationChangeRequest?.length);
      setSelectedRefunds({});
    } catch (err) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handleType = (e)=> {
    let typeName = e?.target?.value;
    setType(typeName);
    setAllLeadData([])
    setAllData([]);
    const missingDateWarning = (!startDate || !endDate);
    if (missingDateWarning) {
      if (typeName === 'paid' || typeName === 'all') {
        props.setSnackInfo(`Please select the date filter and submit to get ${typeName} refund requests`, 'warning');
      } else if (typeName === 'unPaid') {
        props.setSnackInfo(`Please select the date filter and submit to get unpaid refund requests`, 'warning');
      }
    }
    else{
      props.setSnackInfo("Please click on submit button",'success');
    }
  }

  const handleCheckboxChange = (refundId, lead_no, leadId) => {
    setLeadId(leadId);
    setPaidDialog(true);
    const selectedForLead = selectedRefunds[lead_no] || [];
      // Select the refund
      setSelectedRefunds((prevSelected) => ({
        [lead_no]: [...selectedForLead, refundId],
      }));
  };

  const handlePaidSubmit = async()=> {
    try{
        let obj = {
               leadId: leadId,
               remark: remark,
               selectedRefunds : selectedRefunds,
               transactionId: transactionId,
               transactionAttachment: transactionAttachment,
               refundArrayObjId: refundArrayObjId,
               erpProjectId: erpProjectId 
        }
         await HttpService.updateUnpaidLead(obj)
         await HttpService.updateCompanyPLByRefundRaise(obj);
         setPaidDialog(false);
         handleSubmit();
         setTransactionId('');
         setTransactionAttachment('');
         setRemark('');
         setIsFileUploaded(false);
         props.setSnackInfo("Updates Successfully","success");
         setPaidDialog(false);
         setIsFileUploaded(false);
         setSelectedRefunds({});
         setTransactionId('');
         setRemark('');
         setTransactionAttachment('');
    }
    catch(err){
        props.setSnackInfo("Something went wrong",'error')
    }
  }

  // Upload Transaction attachment
  const handleUploadFile = async(e)=>{
    props.setLoading(true)
    try{
        const fd = new FormData();
        fd.append('file', e.target.files[0]);
        const res = await HttpService.uploadFile(fd);
        setTransactionAttachment(res.data);
        setIsFileUploaded(true);
    }
    catch(err){
        props.setSnackInfo("Something went wrong","error");
    }
    props.setLoading(false);
}

const handleCancel = ()=>{
  setPaidDialog(false);
  setIsFileUploaded(false);
  setSelectedRefunds({});
  setTransactionId('');
  setRemark('');
  setTransactionAttachment('');
}

// quoation paid api handle
async function updateUnpaidQuotationHandle() {
  try {
    props.setLoading(true);
    const quotationPaidInfo = {
      quotationId,
      transactionAttachment,
      remark,
      transactionId,
      leadId : leadIdOfQuotaion,
      userName : userDetails?.name,
      userId : userDetails?._id
    }
    await updateCompanyData();
    const fetchData = await HttpService.updateUnpaidQuotation(quotationPaidInfo);
    props.setSnackInfo("Updated Successfully","success");
    setPaidDialog(false);
    setTransactionAttachment("");
    setRemark("");
    setTransactionId("")
    handleSubmit();
    setIsFileUploaded(false);
    props.setLoading(false);
  } catch (error) {
    props.setSnackInfo("Something went wrong","error");
    props.setLoading(false);
  }
}

// update company p&l data
  const updateCompanyData = async () => {
    props.setLoading(true);
    try {
      const { taxPercent, totalAmount, balanceSheetDataObj, grandTotal, totalCustomerOutflow, erpProjectId } = quotationPaidData;
      let obj = {
        leadId: leadIdOfQuotaion,
        quotationId: quotationId,
        taxPercent: taxPercent,
        totalPrice: totalAmount,
        discount: balanceSheetDataObj.discountAmount,
        gst: balanceSheetDataObj.discountAmount,
        grandTotal: grandTotal,
        customerOutflow: totalCustomerOutflow,
        projectId: erpProjectId,
        newTemAddedDataArray: balanceSheetDataObj?.newItemAdded
      }
      const companyPLData = await HttpService.updateCompanyPLData(obj);
      if (companyPLData.status === 200) {
        console.log("company pl data updated")
      }
      else {
        props.setSnackInfo('Something went wrong', "error")
      }
    }
    catch (err) {
      console.error('error: ', err)
    }
    props.setLoading(false)
  }

  const handlePaidButton = (row)=> {
    setrequestType("qotationChangeRequest")
    setQuotationId(row?.quotationId)
    setLeadIdOfQuotaion(row?._id)
    handleCheckboxChange(row?.lead_no)
    setErpProjectId(row?.erpProjectId)
    setQuotationPaidDate(row);
  }

  const handleRefundRaisePaid = (row)=>{
    setrequestType("refundRequest")
    setRefundArrayObjId(row?.refundId)
    setErpProjectId(row?.erpProjectId)
    handleCheckboxChange(row?.refundId, row?.lead_no, row?.projectId)
  }

  return (
    <div>
        <div style={{ marginBottom: 20 }}>
            <h3 style={{ textAlign: "center" }}>
              Finance Refund Approval Dashboard
            </h3>
        </div>
          <Paper className={classes.paper}>
              <br />
              <div>
                  <TextField
                      id="date"
                      name="startDate"
                      label="From Date"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{
                          shrink: true,
                      }}
                      fullWidth
                      className={classes.textField}
                  />
                  <TextField
                      id="date"
                      name="endDate"
                      label="End Date"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{
                          shrink: true,
                      }}
                      fullWidth
                      className={classes.textField}
                  />
                  <Button
                      variant="contained"
                      color="primary"
                      disabled={!startDate || !endDate || !type}
                      style={{marginLeft: 10,"backgroundColor":"#F47E46", color:"#FFF2EB"}}
                      onClick={handleSubmit}
                  >
                      Submit
                  </Button>
                  <Button
                      variant="contained"
                      color="secondary"
                      style={{ margin: 10 }}
                      onClick={() => clearFilterDate()}
                  >
                      Clear Filter
                  </Button>
                  <CSVLink
                    headers={headers}
                    filename={"refundLead" + '.csv'}
                    data={csvData}
                    ref={buttonRef}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.downloadCsvButton}
                    onClick={() => downloadCsv()}
                  >
                    download Csv
                  </Button>
              </div>
              <div
                  style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                  }}
              >
                  <FormControl component="fieldset">
                      <RadioGroup
                          aria-label="type"
                          name="type"
                          value={type}
                          onChange={(e) => handleType(e)}
                      >
                          <div className="modal-header-radio">
                              <FormControlLabel value="paid" control={<Radio />} label="Paid" />
                              <FormControlLabel value="unPaid" control={<Radio />} label="Unpaid" />
                              <FormControlLabel value="all" control={<Radio />} label="All" />
                          </div>
                      </RadioGroup>
                  </FormControl>
              </div>
          </Paper>
        <TableContainer>
            <Table
                className={classes.table}
                stickyHeader
                aria-label="sticky table"
            >
                <TableHead>
                <StyledTableRow>
                  <TablePagination
                        rowsPerPageOptions={[20, 50, 100, 500, { label: "All", value: totalCount }]}
                        count={totalCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </StyledTableRow>
                <StyledTableRow>
                    <StyledTableCell>Sr. No.</StyledTableCell>
                    <StyledTableCell>Customer</StyledTableCell>
                    <StyledTableCell>Lead No</StyledTableCell>
                    <StyledTableCell>Unique Lead No</StyledTableCell>
                    <StyledTableCell>Project No.</StyledTableCell>
                    <StyledTableCell>Department</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Current Stage</StyledTableCell>
                    <StyledTableCell>Assigned to</StyledTableCell>
                    <StyledTableCell>Requested By</StyledTableCell>
                    <StyledTableCell>Refund Amount</StyledTableCell>
                    <StyledTableCell>Request Type</StyledTableCell>
                    <StyledTableCell>Raise Date</StyledTableCell>
                    <StyledTableCell>Refund Status</StyledTableCell>
                    {type === 'unPaid' && <StyledTableCell>Action</StyledTableCell>}
                </StyledTableRow>
                </TableHead>
                <TableBody>
                {allData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((row, i) => (
                      <StyledTableRow key={i}>
                         <StyledTableCell>{i+1}</StyledTableCell>
                         <StyledTableCell component="th" scope="row">{row?.customerName ? row.customerName : row.customerId.name}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to={`/project-logs/${row._id ? row._id : row?.projectId}`}
                            style={{ color: "#000", textDecoration: "underline" }}
                          >
                            {row?.lead_no}
                          </Link>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.uniqueLeadNumber}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.erpProjectNo || '-'}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.departmentName}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.status}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.currentStage}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{typeof row?.assignTo === "object" ? row?.assignTo?.name : row?.assignTo}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.refundRaiseUser ? row?.refundRaiseUser :row?.raisedUser}</StyledTableCell>
                        <StyledTableCell component="th" scope="row"> 
                          {row?.amountRefunded ? row?.amountRefunded : row?.balanceSheetDataObj?.pendingDueAmount}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.balanceSheetDataObj ?  "Quotation Change Request" : "Refund Request"}</StyledTableCell>
                        <StyledTableCell component="th" scope="row">{row?.amountRefunded  ? moment(row.refundRaiseDate).format('DD-MM-YYYY') : moment(row.raiseDate).format('DD-MM-YYYY') }</StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                        {row?.refundStatus || row?.balanceSheetDataObj?.paidInfo?.isPaid ? 'Paid' : 'Unpaid'}
                        </StyledTableCell>
                        {type === 'unPaid' && (
                          <StyledTableCell component="th" scope="row">
                         {
                          (row?.balanceSheetDataObj) ?
                            <Button
                              key={i}
                              variant="contained"
                              color="primary"
                              onClick={() => handlePaidButton(row)}
                              style={{
                                backgroundColor: "#1C375D",
                                color: "#FFF2EB"
                              }}
                            >
                              Paid
                            </Button> :
                            <Button
                              key={i}
                              variant="contained"
                              color="primary"
                              onClick={() => handleRefundRaisePaid(row)}
                              style={{
                                backgroundColor: "#1C375D",
                                color: "#FFF2EB"
                              }}
                            >
                              Paid
                            </Button>
                         }
                          </StyledTableCell>
                        )}
                      </StyledTableRow>
                  ))}
                </TableBody>
            </Table>
        </TableContainer> 

      {/* Move to lost lead in refund request */}
      <Dialog
        open={paidDialog}
        onClose={() => setPaidDialog(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> Confirm Refund Payment</DialogTitle>
        <DialogActions>
          <TableContainer style={{ marginTop: 10 }}>
            <Table size="small">
              <TableBody>
              <TableRow>
                  <TableCell>Remark</TableCell>
                  <TableCell>
                    <TextField
                      name="remark"
                      size="small"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      label="Remark"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Transaction Id</TableCell>
                  <TableCell>
                    <TextField
                      name="transactionId"
                      size="small"
                      value={transactionId}
                      onChange={(e) => setTransactionId(e.target.value)}
                      type="text"
                      label="Enter Transaction Id"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Upload Transaction Attachment</TableCell>
                  <TableCell>
                    <>
                      <TextField
                        accept="*"
                        id="transactionAttachment"
                        type="file"
                        onChange={handleUploadFile}
                        style={{ display: 'none' }}
                      />
                      <label htmlFor={`transactionAttachment`}>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ background: "#355025", color:"#FFF2EB"}}
                          component="span"
                        >
                          Upload
                        </Button>
                        {isFileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                      </label>
                    </>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
              <DialogActions>
              <div style={{ margin: "10px", display:'flex', gap: '10px' }}>
                <Button
                  onClick={handleCancel}
                  color="secondary"
                  variant="contained"
                >
                  Cancel
                </Button>
                {
                  requestType=="refundRequest" && 
                  <Button
                    onClick={handlePaidSubmit}
                    color="primary"
                    variant="contained"
                    disabled = {transactionId <= 0 || transactionAttachment === ''}
                  >
                    Submit
                  </Button>
                  }
                  {
                    requestType=="qotationChangeRequest" && <Button
                    onClick={updateUnpaidQuotationHandle}
                    color="primary"
                    variant="contained"
                    disabled = {transactionId <= 0 || transactionAttachment === ''}
                  >
                    Submit
                  </Button>
                  }
              </div>
            </DialogActions>
          </TableContainer>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default connect(null, { setUserDetails, setLoading, setSnackInfo })(
  RefundApproval
);